<div class="job-pointe-settings-bar row pt-2">
  <div id="left-bar" class="col-12 col-lg-5 align-items-center">
    <div class="col-12 px-1" *ngFor="let filter of filters">
      <div class="form-group">
        <label *ngIf="filter.type !== 'autocomplete'">{{ filter.label }}</label>
        <input
          *ngIf="filter.type === 'text'"
          id="tool-search-input"
          type="text"
          class="form-control"
          [placeholder]="'Select ' + filter.label.toLowerCase()"
          (keyup.enter)="submitFilters(filter.propertyName, $event)" />
        <ng-container *ngIf="filter.model === 'departments'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #departmentsFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'roles'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #rolesFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'employeeTitles'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #employeeTitlesFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'status'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #statusFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'hubStatus'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #hubStatusFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'locals'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #localsFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobCities'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #jobCitiesFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'projectManagers'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #projectManagersFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobAssistants'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #jobAssistantsFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobForeman'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #jobForemanFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'employees'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #employeesFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'employeeUnionClasses'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #employeeUnionClassesFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'defaultStartYear'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindVal]="filter.value"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #defaultStartYearFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'owner'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #ownerFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.type === 'date-range'">
          <input
            type="text"
            class="form-control"
            style="height: 36px"
            name="daterange"
            startKey="start"
            endKey="end"
            [showClearButton]="true"
            [showCancel]="true"
            [(ngModel)]="selectedDateRange"
            (change)="submitDaterangeFilter(filter.propertyName, $event)"
            (clearClicked)="clearDaterangeFilter(filter.propertyName)"
            ngxDaterangepickerMd
            #assignedDateRange
            placeholder="Select a date range" />
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobs'">
          <label>{{ filter.label }}</label>
          <app-job-search-box
            #jobsAutocomplete
            dropdownType="multiple"
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-job-search-box>
        </ng-container>
        <ng-container *ngIf="filter.model === 'facility'">
          <label>{{ filter.label }}</label>
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #facilityFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobBoardAttributes'">
          <label>{{ filter.label }}</label>
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #jobBoardAttributesFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobBoardTags'">
          <label>{{ filter.label }}</label>
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #jobBoardTagsFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'union'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #unionFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'employeeGroups'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #employeeGroupsFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
      </div>
    </div>
  </div>
  <div id="right-bar" class="col d-flex align-items-center">
    <div class="dropdown mt-2 p-2" *ngIf="jobPointeSettingsData.type === 'manageJobs'">
      <button
        *ngIf="isAllowed('manage_jobs', 'edit')"
        [disabled]="selectedItems.length === 0"
        [ngStyle]="{
          'background-color': selectedItems.length > 0 ? '#057aff' : '',
          color: selectedItems.length > 0 ? 'white' : ''
        }"
        class="btn btn-outline-secondary rounded dropdown-toggle"
        type="button"
        id="job-pointe-actions"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        Actions({{ selectedItems.length }})
      </button>
      <div class="dropdown-menu" aria-labelledby="job-pointe-actions">
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'manageJobs'">
          <button type="button" class="btn" (click)="emitAction('addJobs')">Add to Job Board</button>
        </a>
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'manageJobs'">
          <button type="button" class="btn" (click)="emitAction('activateJobs')">Activate</button>
        </a>
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'manageJobs'">
          <button type="button" class="btn" (mousedown)="emitAction('deactivateJobs')">Deactivate</button>
        </a>
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'manageJobs'">
          <button type="button" class="btn" (mousedown)="emitAction('holdJobs')">Put On Hold</button>
        </a>
      </div>
    </div>

    <div
      *ngIf="
        searchBarSide === 'right' &&
        ['employees', 'jobBoardEmployees', 'manageJobs', 'jobBoard'].includes(jobPointeSettingsData.type)
      "
      id="search-input"
      class="col-12 col-sm-6 col-md col-lg-4 px-2">
      <div style="position: relative">
        <div class="form-group">
          <label style="visibility: hidden">Search</label>
          <input
            [(ngModel)]="searchInput"
            id="tool-search-input"
            type="text"
            class="form-control"
            placeholder="Search"
            (keyup.enter)="submitSearch()" />
          <button type="button" class="right" (click)="onSearchAction()">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <ng-container *ngIf="jobPointeSettingsData.type == 'transfers'">
      <button class="btn btn-success" (click)="submitSearch()" id="transfers-save">Search</button>
    </ng-container>

    <ng-container *ngIf="jobPointeSettingsData.type == 'transfers'">
      <button class="btn btn-light text-dark" (click)="clearFilter()" id="transfers-clear">Clear</button>
    </ng-container>
    <!-- Export -->
    <div class="dropdown dropleft" *ngIf="jobPointeSettingsData.type == 'employees' && isAllowed('employees', 'edit')">
      <button
        class="btn btn-primary"
        type="button"
        id="job-pointe-export"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        Export
      </button>
      <div class="dropdown-menu" aria-labelledby="job-pointe-export">
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'employees'">
          <button type="button" class="btn" (click)="emitExport()" (mousedown)="setJobPointeExportType('default')">
            Export {{ capitalize(jobPointeSettingsData.type) }} Data
          </button>
        </a>
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'employees'">
          <button
            type="button"
            class="btn"
            (click)="emitExport('activeEmployees')"
            (mousedown)="setJobPointeExportType('default')">
            Export Active {{ capitalize(jobPointeSettingsData.type) }} Data
          </button>
        </a>
        <a class="dropdown-item" *ngIf="jobPointeSettingsData.type == 'employees'">
          <button
            type="button"
            class="btn"
            (click)="emitCertsTagsExport('certsTags')"
            (mousedown)="setJobPointeExportType('default')">
            Export {{ capitalize(jobPointeSettingsData.type) }} Certs &amp; Tags
          </button>
        </a>
      </div>
    </div>
    <ng-container *ngIf="jobPointeSettingsData.type == 'configuration'">
      <button type="button" id="job-pointe-setting-add-button" class="btn btn-primary" (click)="submitCreate()">
        Add New Attribute{{ jobPointeSettingsData.label }}
      </button>
    </ng-container>

    <ng-container *ngIf="jobPointeSettingsData.type == 'manageEmployee'">
      <button type="button" id="add-employee-button" class="btn btn-primary" (click)="addEmployee()">
        Add Employee
      </button>
    </ng-container>
  </div>
</div>
<div
  class="filter-options"
  style="background: white; margin-left: -1.13%; padding: 0.1% 2%"
  *ngIf="
    ['employees', 'configuration', 'manageJobs', 'jobBoardEmployees', 'jobBoard'].includes(jobPointeSettingsData.type)
  ">
  <ul class="list-unstyled d-flex">
    <li><a href="javascript:;" (click)="saveFilter()">Save Filters</a></li>
    <li class="divider">|</li>
    <li><a href="javascript:;" (click)="clearFilter()">Clear Filters</a></li>
  </ul>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="moreFilter" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#" id="FiltersForm">
        <div class="modal-header">
          <h5 class="modal-title">More Filters</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" *ngFor="let filter of moreFilters">
          <ng-container *ngIf="filter.model === 'asset-classes'">
            <app-autocomplete-dropdown
              [model]="filter.model"
              [bindLabel]="filter.name"
              [propertyName]="filter.propertyName"
              [type]="filterType"
              [label]="filter.label"
              dropdownType="multiple"
              [inputItems]="filter.options"
              #assetClassDropDownFilter
              (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
          </ng-container>
          <!-- status -->
          <ng-container *ngIf="filter.model === 'assignment_types'">
            <app-autocomplete-dropdown
              [model]="filter.model"
              [bindLabel]="filter.name"
              [propertyName]="filter.propertyName"
              [type]="filterType"
              [label]="filter.label"
              dropdownType="multiple"
              [inputItems]="filter.options"
              #assignmentTypesDropDownFilter
              (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
          </ng-container>
          <!-- Shop Origination -->
          <ng-container *ngIf="filter.model === 'shop_origination_id'">
            <app-autocomplete-dropdown
              [model]="filter.model"
              [bindLabel]="filter.name"
              [propertyName]="filter.propertyName"
              [type]="filterType"
              [label]="filter.label"
              dropdownType="multiple"
              [inputItems]="filter.options"
              #shopOriginationDropDownFilter
              (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
          </ng-container>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closeFilterModel data-dismiss="modal">
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Filter Modal End-->
